import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { apiClient } from '../../api/client';
import UserIdModal from '../UserIdModal/UserIdModal';

interface SetUserIdStatusResponse {
  hasSetUserId: boolean;
  sellerId?: string;
}

const UserIdCheck: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [hasSetUserId, setHasSetUserId] = useState<boolean | null>(null);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);

  useEffect(() => {
    const checkSellerIdStatus = async () => {
      if (isAuthenticated && !isLoading) {
        setIsCheckingStatus(true);
        try {
          const response = await apiClient.users.getUserIdStatus() as SetUserIdStatusResponse;
          setHasSetUserId(response.hasSetUserId);
        } catch (error) {
          console.error('Error checking seller ID status:', error);
          // Default to false to ensure the modal is shown if there's an error
          setHasSetUserId(false);
        } finally {
          setIsCheckingStatus(false);
        }
      }
    };

    checkSellerIdStatus();
  }, [isAuthenticated, isLoading]);

  // Don't render anything while loading or checking status
  if (isLoading || isCheckingStatus || hasSetUserId === null) {
    return null;
  }

  // Handler to close the modal and update the state
  const handleModalClose = () => {
    setHasSetUserId(true);
  };

  // Only show the modal if the user is authenticated and hasn't set a seller ID
  return (
    <UserIdModal
      isOpen={isAuthenticated && !hasSetUserId}
      onClose={handleModalClose}
    />
  );
};

export default UserIdCheck;